import styled from '@emotion/styled'

export const EstimateComparePageStyled = styled.div`
  label: EstimateComparePageStyled;
  .banner-main-bg .banner-content p {
    font-size: 20px;
    font-weight: bold;
    max-width: 840px;
    line-height: 36px;
    font-weight: 800;
  }
  .banner-main-bg .banner-content,
  .review-proposal-page .banner-main-bg .banner-content,
  .banner-estimate-bg .banner-main-bg .banner-content {
    max-width: 1140px;
    margin: 0 auto;
  }
  .estimate-list {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    position: relative;
    top: 32px;

    .react-multiple-carousel__arrow {
      top: 200px;
    }
    .react-multi-carousel-list {
      padding: 0;
      margin-top: 32px;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.mq.xl}) {
    .compare-estimate-page
      .navigators.estimate-list
      .react-multiple-carousel__arrow {
      display: none;
    }
  }
`
export const EstimateCompareIntro = styled.div`
  label: EstimateCompareIntro;
  text-align: center;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textDarkblack};
`
export const EstimateItemWrapper = styled.div`
  label: EstimateItemWrapper;
  display: flex;
  justify-content: center;
  height: 100%;
`

export const ReleaseBannerDesktopDiv = styled.div`
  label: ReleaseBannerDesktopDiv;
  float: right;
  min-width: 300px;
`

export const ReleaseBannerMobileDiv = styled.div`
  label: ReleaseBannerMobileDiv;
  padding-bottom: 12px;
  display: flex;
  justify-content: center;
`
